import React, { useEffect, useRef } from 'react'

import {
  getSubscription,
  getSubscriptionLoading,
} from '@disco/state-management/selectors/subscription'
import { getChargebeeInstance } from '@disco/utils/chargebee'

import { useSelector } from 'hooks/use-redux'

type TokenizeParams = {
  firstName?: string
  lastName?: string
}
// resolves with the Chargebee token payload; shape is defined by the external SDK
type Tokenize = (params: TokenizeParams) => Promise<any>
export type ChargebeeComponent = {
  tokenize: Tokenize
}
export const ChargebeeFormInputs = ({
  chargebeeLoaded,
  onReady,
}: {
  chargebeeLoaded: boolean
  onReady: (chargebeeComponent: ChargebeeComponent) => void
}) => {
  const mountRef = useRef<HTMLDivElement>(null)
  const subscription = useSelector(getSubscription)
  const isSubscriptionLoading = useSelector(getSubscriptionLoading)
  const hasMounted = useRef(false)

  const currencyCode = subscription?.currency_code

  useEffect(() => {
    // mid-fetch getSubscription returns a placeholder with no currency_code, and the card
    // component is only ever created once, so mounting now would lock in the wrong currency
    if (!chargebeeLoaded || hasMounted.current || isSubscriptionLoading) return

    async function loadChargebeeComponent() {
      const cbInstance = getChargebeeInstance()
      await cbInstance.load('components')

      // an undefined currency is expected for users with no subscription to fetch;
      // Chargebee then falls back to the site's base currency
      const component = cbInstance.createComponent('card', {
        currency: currencyCode,
      })
      component.mount(mountRef.current)
      hasMounted.current = true

      onReady(component)
    }

    loadChargebeeComponent()
  }, [chargebeeLoaded, isSubscriptionLoading, currencyCode, onReady])

  return <div className="ChargebeeCardForm" ref={mountRef} />
}
